import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScanInputComponent } from './scan-input/scan-input.component';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { CommonAppModule } from '../common-app/common-app.module';



@NgModule({
  declarations: [
    ScanInputComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    CommonAppModule
  ],
  exports: [
    ScanInputComponent
  ]
})
export class CommonOperationsModule { }
